import React, { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { fullSensitivityConfigAtom } from './atoms';
import SensitivityDrawer from './SensitivityDrawer';
import { SensitivityConfig } from './interface';
import useAIAlertMetricsMeta from '../../hooks/useAIAlertMetricsMeta';
import { getDefaultMetricsSensitivityConfig } from './utils';

const SensitivityControl = (props) => {
  const { isPopupOpen } = props;
  const { aiAlertMetricKeys, sensitivityResponseData: sensitivityData = [] } =
    useAIAlertMetricsMeta(isPopupOpen, []);
  const setFullSensitivityData = useSetAtom(fullSensitivityConfigAtom);

  useEffect(() => {
    const sensitivityConfigs: SensitivityConfig[] = getDefaultMetricsSensitivityConfig(
      sensitivityData,
      aiAlertMetricKeys,
    );

    setFullSensitivityData(sensitivityConfigs);
  }, [sensitivityData]);

  const cancelEdit = () => {
    setFullSensitivityData([]);
    props.cancelEdit();
  };

  return <SensitivityDrawer {...props} cancelEdit={cancelEdit} />;
};

export default React.memo(SensitivityControl);
